// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"168b0f57","867":"22914931","879":"6b97990f"}[chunkId] + ".chunk.js";
};